module.exports = __webpack_public_path__ + "assets/1792649897182/img/pdf-icon.62a988af.png";